import loadable from '@wix/yoshi-flow-editor/loadable';
import type {LoadedLayoutProps} from './LoadedLayout';

type LoadedLayoutLazyProps = LoadedLayoutProps & {fallback?: React.JSX.Element};

const ILoadedLayoutLazy = loadable(
  () =>
    import(
      /* webpackChunkName: "CheckoutLoadedLayout" */
      './LoadedLayout'
    ),
  {
    resolveComponent: (components) => components.LoadedLayout,
  }
);
/* istanbul ignore next */
if (typeof window !== 'undefined') {
  ILoadedLayoutLazy.preload();
}

export const LoadedLayoutLazy = ILoadedLayoutLazy as React.ComponentType<LoadedLayoutLazyProps>;
